<template>
  <div class="txn-wrap">
    <div id="blockTime" class="line-chart"></div>
  </div>
</template>

<script>
let echarts = require('echarts')
export default {
  name: 'BlockNum',
  data() {
    return {
      chart: null,
      intervalId: null,
      option: {
        grid: {
          left: '1%',
          right: '7%',
          bottom: '0%',
          top: '8%',
          containLabel: true
        },
        xAxis: {
          name: '秒', // 在 x 轴末尾添加描述
          nameLocation: 'end', // 指定描述位置为末尾
          nameTextStyle: { color: '#fff' },
          type: 'category',
          // data: ['0---0.01', '0.01---0.05', '0.05---1', '1---5', '5---Infinity'],
          interval: 0,
          splitNumber: 5,
          axisLabel: {
            fontSize: 12,
            rotate: 35,
            interval: 0,
            textStyle: {
              color: '#fff' // 修改 y 坐标轴标签的字体颜色为红色
            }
          },
          axisTick: {
            // 去掉刻度
            show: false
          },
          axisLine: {
            // 修改轴线颜色
            lineStyle: {
              color: '#306269'
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#306269',
              width: 0.4
            }
          },
          axisLabel: {
            fontSize: 12,
            textStyle: {
              color: '#fff' // 修改 y 坐标轴标签的字体颜色为红色
            }
          }
        },
        series: [
          // {
          //     type: 'bar',
          //     barWidth: 14,
          //     showBackground: true,
          //     backgroundStyle: {
          //         // 背景样式配置
          //         color: '#0A2936' // 设置背景颜色为红色
          //     },
          //     itemStyle: {
          //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //             {
          //                 offset: 0,
          //                 color: '#FFCC00'
          //             },
          //             {
          //                 offset: 1,
          //                 color: '#131D21'
          //             }
          //         ])
          //     }
          // }
        ]
      }
    }
  },
  watch: {
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData()
    }
  },
  mounted() {
    this.initChart()
    this.getData()
    this.intervalId = setInterval(() => {
      this.getData()
    }, 3000)
    window.addEventListener('resize', this.resize, false)
  },
  destroyed() {
    // 清除定时器和图表实例
    clearInterval(this.intervalId)
    this.chart.dispose()
  },

  methods: {
    initChart() {
      let container = document.getElementById('blockTime')
      let chart = echarts.init(container)
      chart.setOption(this.option)
      this.chart = chart
    },
    resize() {
      this.chart.resize()
    },
    getData() {
      let cid = this.$store.state.home.chainCid

      let params = {
        chain_id: cid,
        data_type: 4,
        query_range: 0,
        query_step: '',
        query_time: Math.floor(Date.now() / 1000)
      }
      this.$apis.home.getSingle(params).then(res => {
        if (res.data) {
          // let result = this.handleLine(res.data)
          let xArray = ['0']
          var seriesArray = []

          var obj = {
            type: 'bar',
            barWidth: 14,
            showBackground: true,
            backgroundStyle: {
              // 背景样式配置
              color: '#0A2936' // 设置背景颜色为红色
            },
            data: [],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#FFCC00'
                },
                {
                  offset: 1,
                  color: '#131D21'
                }
              ])
            }
          }
          res.data.map((item, index) => {
            xArray.push(item.axis)
            obj.data.push(item.nums)
          })
          const numericArray = xArray.map(value => {
            if (value === 'Inf') {
              return Infinity
            } else {
              return parseFloat(value)
            }
          })
          numericArray.sort((a, b) => a - b)

          const newArray = numericArray
            .map((value, index, array) => {
              if (index === 0 && array.length > 1) {
                return `${value}-${array[index + 1]}`
              } else if (index < array.length - 1) {
                return `${array[index - 1]}-${value}`
              } else {
                return `${array[index - 1]}-${value}`
              }
            })
            .filter((value, index, array) => value !== array[index - 1])

          seriesArray.push(obj)
          this.chart.setOption({
            animation: true,
            xAxis: {
              data: newArray
            },
            series: seriesArray
          })
        }
      })
    },
    handleLine(data) {
      let hour = []
      let num = []
      data.map(ele => {
        let time = this.format(ele.Hourtime)
        hour.push(time)
        num.push(ele.Num)
      })
      return [hour, num]
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    format(timeStamp) {
      let time = new Date(timeStamp * 1000)
      let m = time.getMonth() + 1
      let d = time.getDate()
      let h = time.getHours()
      let mm = time.getMinutes()
      let s = time.getSeconds()
      return this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/compatible/index.scss';

.real-wrap,
.line-chart {
  @include px2vw(width, 420);
  @include px2vw(height, 230);
}
</style>
